import { bindActionCreators } from "@reduxjs/toolkit";
import { useMemo } from "react";
import { useDispatch } from "react-redux";

import {
  activateCompanyContext,
  activatePrivateContext,
  initializeCompanyContext,
  setLanguage,
  setSessionMini,
  toggleSidebar,
} from "@shared/api/reduxToolkit";

const rootActions = {
  activatePrivateContext,
  activateCompanyContext,
  initializeCompanyContext,

  setLanguage,

  toggleSidebar,
  setSessionMini,
};

export const useActions = () => {
  const dispatch = useDispatch();

  return useMemo(() => bindActionCreators(rootActions, dispatch), [dispatch]);
};
